import { useEffect, useState } from "react";
import { UserRoles } from "fe-common/graphql";
import { useGetUserRoles } from "fe-web-components/roles/useGetUserRoles";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";

export function useClinicUserRoles(clinicId: string) {
  const dao = useClinicContext();
  const [userClinicRoles, setUserClinicRoles] = useState<UserRoles[]>([]);
  const { roles: userRoles, loading: loadingUserRoles } = useGetUserRoles();
  const [loadingClinicUserRoles, setLoadingClinicUserRoles] = useState(true);
  const [hasAdminAccess, setHasAdminAccess] = useState(false);
  const [hasManagerAccess, setHasManagerAccess] = useState(false);
  const [hasSuperAccess, setHasSuperAccess] = useState(false);

  useEffect(() => {
    const hasRoles = (roles: UserRoles[]) => {
      return userRoles.some((ur) => roles.includes(ur));
    };

    if (!loadingUserRoles) {
      setUserClinicRoles((prev) => [...prev, ...userRoles]);
      setHasSuperAccess(hasRoles([UserRoles.KahunClinicSuperAdmins]));
      setHasAdminAccess(
        hasRoles([
          UserRoles.KahunClinicAdmins,
          UserRoles.KahunClinicSuperAdmins,
        ]),
      );
    }
  }, [loadingUserRoles, userRoles]);

  useEffect(() => {
    if (hasSuperAccess || hasAdminAccess) setHasManagerAccess(true);
    else if (clinicId) {
      dao.getCurrentClinicUser(clinicId).then((data) => {
        if (data?.role) {
          setUserClinicRoles((prev) => [...prev, data.role]);
          setHasManagerAccess(data.role === UserRoles.KahunClinicManager);
        }
        setLoadingClinicUserRoles(false);
      });
    }
  }, [clinicId, dao, hasAdminAccess, hasSuperAccess]);

  return {
    loading: loadingClinicUserRoles || loadingUserRoles,
    roles: userClinicRoles,
    hasSuperAccess,
    hasAdminAccess,
    hasManagerAccess,
  };
}
